import { WizardStep } from "../../../common/wizard/types";

export type { WizardMode, WizardStep } from "../../../common/wizard/types";

export const DEAL_WIZARD_STEPS: WizardStep[] = [
  { key: "merchant", title: "Merchant details" },
  { key: "inPersonPricing", title: "In-person pricing" },
  { key: "onlinePricing", title: "Online pricing" },
];
